// extracted by mini-css-extract-plugin
export default {"container":"Owner_container__Kph+0","name":"Owner_name__JhVJ9"};